import { render, staticRenderFns } from "./RedirectOverlay.vue?vue&type=template&id=32cc057d&scoped=true"
import script from "./RedirectOverlay.vue?vue&type=script&lang=js"
export * from "./RedirectOverlay.vue?vue&type=script&lang=js"
import style0 from "./RedirectOverlay.vue?vue&type=style&index=0&id=32cc057d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32cc057d",
  null
  
)

export default component.exports